import { makeStyles, Theme, createStyles, Typography, Button, ButtonProps } from "@material-ui/core";
import { observer } from "mobx-react";
import ErrorAvatar from "./ErrorAvatar";
import { CheckBold } from "mdi-material-ui";
import DynamicIcon from "../../shared/general/components/DynamicIcon";
import { IconName } from "../../stores/models/Icon";
import { useMemo } from "react";
import clsx from 'clsx';
import REMAvatar from "../../shared/modules/rem-conversion/components/Avatar";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            '& > *:not(:last-child)': {
                marginBottom: theme.spacing(2)
            }
        },
        errorTitle: {
            marginTop: theme.spacing(1)
        },
        icon: {
            color: theme.palette.success.main,
            fontSize: '30px'
        },
        lightIcon: {
            color: theme.palette.common.white,
            fontSize: '35px'
        },
        avatar: {
            background: 'none',
            margin: 'auto',
            height: 75,
            width: 75,
            marginBottom: theme.spacing(2),
        },
        avatarBorder: {
            border: '3px solid',
            borderColor: theme.palette.success.main,
        },
        filled: {
            background: theme.palette.success.main
        },
    }));

interface SuccessOrErrorMessageProps {
    success?: boolean;
    icon?: IconName;
    filled?: boolean;
    title: string;
    details: string | JSX.Element;
    ButtonProps?: ButtonProps;
    footerDetails?: JSX.Element;
}

const SuccessOrErrorMessage = observer((props: SuccessOrErrorMessageProps) => {

    /********* React hooks *********/

    const classes = useStyles();
    const avatarClasses = useMemo(() => clsx(classes.avatar, props.filled ? classes.filled : classes.avatarBorder), [props.filled]);
    const iconClasses = useMemo(() => props.filled ? classes.lightIcon : classes.icon, [props.filled]);

    /********* Render *********/

    return (
        <div id='success-or-error-message' className={classes.root}>
            {props.success
                ? <REMAvatar className={avatarClasses}>
                    {props.icon
                        ? <DynamicIcon icon={props.icon} attributes={{ className: iconClasses }} />
                        : <CheckBold className={iconClasses} fontSize={'large'} />
                    }
                </REMAvatar>
                : <ErrorAvatar />
            }
            <Typography variant="h4" className={classes.errorTitle}>{props.title}</Typography>
            {typeof props.details === 'string'
                ? <Typography>{props.details}</Typography>
                : props.details
            }
            {props.ButtonProps && <Button variant="contained" color="primary" {...props.ButtonProps} />}
            {props.footerDetails}
        </div>
    );
});

export default SuccessOrErrorMessage;